/**
 * NOTE: This mixin is deprecated. Please use the `useWhiteLabeling`
 *       composable going forward.
 *
 * @deprecated
 */

import get from "lodash/get";

export default {
    computed: {
        isWhiteLabeled() {
            const live_url = get(window, 'SERVER_DATA.live_url', null);

            if (live_url !== null) {
                return !window.location.origin.includes(live_url);
            }

            return false;
        },
    }
}
